import { render, staticRenderFns } from "./PilotSpecification.vue?vue&type=template&id=084c2efe&scoped=true&"
import script from "./PilotSpecification.vue?vue&type=script&lang=ts&"
export * from "./PilotSpecification.vue?vue&type=script&lang=ts&"
import style0 from "./PilotSpecification.vue?vue&type=style&index=0&id=084c2efe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c2efe",
  null
  
)

export default component.exports